(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.custom-header');
    const mobileToggle = document.querySelector('.custom-header__mobile-toggle');
    const mobileMenu = document.querySelector('.custom-header__mobile-menu');
    const mobileClose = document.querySelector('.custom-header__mobile-close');

    // Create and append overlay element
    //   const overlay = document.createElement('div');
    //   overlay.classList.add('custom-header__overlay');
    //   document.body.appendChild(overlay);

    // Add scroll event to add shadow on scroll
    window.addEventListener('scroll', function () {
      if (window.scrollY > 0) {
        header.classList.add('custom-header--scrolled');
      } else {
        header.classList.remove('custom-header--scrolled');
      }
    });

    // Mobile menu toggle functionality
    if (mobileToggle && mobileMenu && mobileClose) {
      // Open mobile menu
      mobileToggle.addEventListener('click', function (e) {
        e.preventDefault();
        mobileMenu.classList.add('active');
        //overlay.classList.add('active');
        mobileToggle.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
      });

      // Close mobile menu
      function closeMenu() {
        mobileMenu.classList.remove('active');
        // overlay.classList.remove('active');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = ''; // Re-enable scrolling
      }

      mobileClose.addEventListener('click', closeMenu);
      //overlay.addEventListener('click', closeMenu);

      // Close menu when clicking on mobile menu links
      const mobileMenuLinks = mobileMenu.querySelectorAll('.custom-header__mobile-menu-link');
      mobileMenuLinks.forEach((link) => {
        link.addEventListener('click', closeMenu);
      });

      // Close on ESC key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
          closeMenu();
        }
      });
    }

    // Mega-menu function
    const megaMenus = document.querySelectorAll(
      '.custom-header__menu .mega_menu-item, .custom-header__mobile-menu-list .mega_menu-item'
    );

    function setupMegaMenus() {
      megaMenus.forEach((menuItem) => {
        const trigger = menuItem.querySelector('.trigger_menu');
        const content = menuItem.querySelector('.mega_menu_content');
        if (!trigger || !content) return;

        // Remove any existing event listeners before re-adding
        trigger.replaceWith(trigger.cloneNode(true));
        content.style.display = 'none';
        content.classList.remove('active');
        menuItem.querySelector('.trigger_menu').classList.remove('active');

        const newTrigger = menuItem.querySelector('.trigger_menu');

        function openMenu() {
          newTrigger.classList.add('active');
          content.classList.add('active');
          content.style.display = 'block';
        }

        function closeMenu() {
          newTrigger.classList.remove('active');
          content.classList.remove('active');
          content.style.display = 'none';
        }

        function toggleMenu() {
          const isActive = newTrigger.classList.contains('active');
          // Close all other menus
          megaMenus.forEach((item) => {
            item.querySelector('.trigger_menu')?.classList.remove('active');
            const otherContent = item.querySelector('.mega_menu_content');
            if (otherContent) {
              otherContent.classList.remove('active');
              otherContent.style.display = 'none';
            }
          });
          if (!isActive) openMenu();
        }

        if (window.innerWidth > 1199) {
          // 🖱 Desktop: hover
          menuItem.addEventListener('mouseenter', openMenu);
          menuItem.addEventListener('mouseleave', closeMenu);
        } else {
          // 📱 Mobile: click/toggle
          newTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            toggleMenu();
          });
        }
      });
    }

    // Initialize
    setupMegaMenus();

    // Reinitialize on resize (with debounce)
    window.addEventListener('resize', () => {
      clearTimeout(window.megaMenuResizeTimeout);
      window.megaMenuResizeTimeout = setTimeout(setupMegaMenus, 300);
    });
    // Mega-menu function
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
